import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorComponent from "@app/components/errorState";
import { ReactComponent as NoResultFoundSVG } from "@app/assets/no-result-found.svg";
import { ERROR_SCREEN } from "@app/utils/constants";
import { resetNoResultFound } from "@app/redux/actions/apps/actions";

const NoResultFound = (): JSX.Element => {
    const dispatch = useDispatch();
    const { appDetails } = useSelector((state: any) => state);

    useEffect(() => {
        return () => {
            if (appDetails?.noResultFound) {
                dispatch(resetNoResultFound());
            }
        };
    }, []);

    return (
        <ErrorComponent
            SvgErrorIcon={NoResultFoundSVG}
            header={ERROR_SCREEN.NO_RESULT_FOUND.HEADER_TEXT}
            message={ERROR_SCREEN.NO_RESULT_FOUND.DETAILED_TEXT}
            isErrorPage={true}
            displayButton={true}
        />
    );
};

export default React.memo(NoResultFound);
